import { storeToRefs } from 'pinia'
import VueRouter from 'vue-router'
import pages from './pages'
import useAuthStore from '@/store/auth'
import useCentralStore from '@/store/central'
import { clearDataStores } from '@/utils/store'

const routes = [
  // ? We are redirecting to different pages based on role.
  // NOTE: Role is just for UI purposes. ACL is based on abilities.
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/erro404/Error404.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/sucesso',
    name: 'auth-success',
    component: () => import('@/views/success/Success.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/:empresaNomeFormatado/:autoatendimentoNomeFormatado',
    name: 'index',
    redirect: to => {
      const { isLoggedIn } = storeToRefs(useAuthStore())

      if (isLoggedIn.value) {
        return { name: 'autoatendimentoView', to }
      }

      return { name: 'auth-login', to }
    },
  },
  {
    path: '/:empresaNomeFormatado/:autoatendimentoNomeFormatado/cadastro',
    name: 'auth-cadastro',
    component: () => import('@/views/acesso-cliente/Cadastro.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/:empresaNomeFormatado/:autoatendimentoNomeFormatado/login',
    name: 'auth-login',
    component: () => import('@/views/acesso-cliente/Login.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/:empresaNomeFormatado/:autoatendimentoNomeFormatado/completar-cadastro',
    name: 'auth-completar-cadastro',
    component: () => import('@/views/acesso-cliente/CompletarCadastro.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/:empresaNomeFormatado/:autoatendimentoNomeFormatado/trocar-senha',
    name: 'auth-trocar-senha',
    component: () => import('@/views/acesso-cliente/SolicitacaoTrocaSenha.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/:empresaNomeFormatado/:autoatendimentoNomeFormatado/resetar-senha',
    name: 'auth-resetar-senha',
    component: () => import('@/views/acesso-cliente/ResetarSenha.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/:empresaNomeFormatado/:autoatendimentoNomeFormatado/confirmacao-cadastro',
    name: 'auth-confirmacao-cadastro',
    component: () => import('@/views/acesso-cliente/ConfirmacaoCadastro.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/:empresaNomeFormatado/:autoatendimentoNomeFormatado/atendimentos',
    name: 'autoatendimentoView',
    component: () => import('@/views/autoatendimento/AtendimentoTickets.vue'),
    meta: {
      layout: 'content',
    },
  },

  ...pages,
  {
    path: '*',
    redirect: 'error-404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

function rotaPertenceAoGrupoDeAutenticacao(routeName) {
  return [
    'auth-login',
    'auth-cadastro',
    'auth-trocar-senha',
    'auth-resetar-senha',
    'auth-confirmacao-cadastro',
  ].includes(routeName)
}

router.beforeEach((to, _, next) => {
  const {
    empresaNomeFormatado: empresaNomeFormatadoParam,
    autoatendimentoNomeFormatado: autoatendimentoNomeFormatadoParam,
  } = to.params

  const { isLoggedIn } = storeToRefs(useAuthStore())

  const { setRequestUrl, updateTitle } = useCentralStore()
  const {
    isRequestUrlDefinida,
    empresaNomeFormatado: empresaNomeFormatadoStore,
    autoatendimentoNomeFormatado: autoatendimentoNomeFormatadoStore,
  } = storeToRefs(useCentralStore())

  if (to.name === 'error-404') {
    return next()
  }
  if (to.name !== 'error-404' && (!empresaNomeFormatadoParam || !autoatendimentoNomeFormatadoParam)) {
    return next({ name: 'error-404' })
  }

  if (!rotaPertenceAoGrupoDeAutenticacao(to.name) && !isLoggedIn.value) {
    return next({
      name: 'auth-login',
      params: {
        empresaNomeFormatado: empresaNomeFormatadoParam,
        autoatendimentoNomeFormatado: autoatendimentoNomeFormatadoParam,
      },
    })
  }

  if (!isRequestUrlDefinida.value) {
    setRequestUrl(empresaNomeFormatadoParam, autoatendimentoNomeFormatadoParam)
    return next()
  }

  if (empresaNomeFormatadoParam !== empresaNomeFormatadoStore.value || autoatendimentoNomeFormatadoParam !== autoatendimentoNomeFormatadoStore.value) {
    clearDataStores()
    return next({
      name: 'auth-login',
      params: {
        empresaNomeFormatado: empresaNomeFormatadoParam,
        autoatendimentoNomeFormatado: autoatendimentoNomeFormatadoParam,
      },
    })
  }

  updateTitle()

  return next()
})

export default router
